import React from 'react'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text'
import { Sheet, SheetContent, SheetOverlay } from '@wartek-id/sheet-v1'

type LogoutSheetProps = {
  isOpen: boolean
  onClose: () => void
}

export default function LogoutSheet({ isOpen, onClose }: LogoutSheetProps) {
  const router = useRouter()
  const onLogout = () => {
    router.push('/logout')
  }

  return (
    <>
      <Sheet
        isOpen={isOpen}
        onClose={onClose}
        sheetSize="auto"
        autoFocus={false}
      >
        <SheetOverlay />
        <SheetContent className="max-w-xl m-auto">
          <div className="py-6 px-4 leading-normal">
            <Text variant="heading-md" className="mb-2">
              Keluar dari akun Anda?
            </Text>
            <Text variant="body" className="mb-4">
              Beberapa fitur tidak akan bisa diakses hingga Anda masuk kembali.
            </Text>
            <Button
              color="black"
              size="md"
              fullWidth
              className="mb-3"
              onClick={onLogout}
            >
              Keluar Akun
            </Button>
            <Button color="white" size="md" fullWidth onClick={onClose}>
              Batal
            </Button>
          </div>
        </SheetContent>
      </Sheet>
    </>
  )
}
